import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { ToastContainer } from "react-toastify";

import { CheckPermission } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiFund } from "../../funds/ApiFund";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage, SelectOnlyDate } from "../../helper/Method";
import FundsReport from "../../funds/report/FundReportList";
import InfaqSearchFilters from "./InfaqSearchFilters";
import UnitWiseInfaqReport from "./unitWiseReport/UnitWiseInfaqReport";

const TAB_UNIT_WISE = "unitWise";
const TAB_RAFIQ_WISE = "rafiqWise";

const getInitialValues = () => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const tempDate = new Date();
  tempDate.setDate(1);
  return {
    unit: { value: loggedInUnitId, lable: "" },
    isSubUnits: true,
    displayMemberDetails: true,
    startDate: SelectOnlyDate(tempDate),
    excludeExUnit: true,
    endDate: SelectOnlyDate(new Date()),
    showAmount: false,
    memberTypeIds: [],
  };
};

const InfaqReport = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab");
  const initialTab =
    tabParam === TAB_RAFIQ_WISE ? TAB_RAFIQ_WISE : TAB_UNIT_WISE;
  const showAmount = CheckPermission("CanViewInfaqAmount");

  const [activeTab, setActiveTab] = useState(initialTab);
  const [values, setValues] = useState(getInitialValues);
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unitWiseData, setUnitWiseData] = useState({
    cumulativeFund: { monthModels: [] },
    unitFundsDetails: [],
  });
  const [rafiqWiseData, setRafiqWiseData] = useState({
    cumulativeFund: { totalMembers: 0, monthModels: [] },
    memberFundsDetails: [],
  });

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    setActiveTab(tab === TAB_RAFIQ_WISE ? TAB_RAFIQ_WISE : TAB_UNIT_WISE);
  }, [location.search]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSearch = (searchValues) => {
    if (loading) return;
    setLoading(true);
    setSearchTriggered(true);

    Promise.all([
      ApiFund().getUnitWiseFundsDetails(searchValues),
      ApiFund().getMembersFundsDetails(searchValues),
    ])
      .then(([unitWiseRes, rafiqWiseRes]) => {
        setUnitWiseData({
          cumulativeFund: unitWiseRes.data,
          unitFundsDetails: unitWiseRes.data.unitFundsDetails,
        });
        setRafiqWiseData({
          cumulativeFund: rafiqWiseRes.data,
          memberFundsDetails: rafiqWiseRes.data.memberFundsDetails,
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      <div className="ibox">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="infaq_report_title" />}</h5>
        </div>
        <InfaqSearchFilters
          values={values}
          setValues={setValues}
          onSubmit={handleSearch}
          showAmount={showAmount}
          loading={loading}
        />
      </div>
      <div className="tabs-container">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === TAB_UNIT_WISE ? "active" : ""}
              onClick={() => toggle(TAB_UNIT_WISE)}
              style={{ cursor: "pointer" }}
            >
              <GetLanguageString props="infaq_report_tab_unit_wise" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === TAB_RAFIQ_WISE ? "active" : ""}
              onClick={() => toggle(TAB_RAFIQ_WISE)}
              style={{ cursor: "pointer" }}
            >
              <GetLanguageString props="infaq_report_tab_rafiq_wise" />
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={TAB_UNIT_WISE}>
            <div className="panel-body">
              <UnitWiseInfaqReport
                embedded
                isActive={activeTab === TAB_UNIT_WISE}
                values={values}
                cumulativeFund={unitWiseData.cumulativeFund}
                unitFundsDetails={unitWiseData.unitFundsDetails}
                loading={loading}
                searchTriggered={searchTriggered}
              />
            </div>
          </TabPane>
          <TabPane tabId={TAB_RAFIQ_WISE}>
            <div className="panel-body">
              <FundsReport
                embedded
                isActive={activeTab === TAB_RAFIQ_WISE}
                values={values}
                cumulativeFund={rafiqWiseData.cumulativeFund}
                memberFundsDetails={rafiqWiseData.memberFundsDetails}
                loading={loading}
                searchTriggered={searchTriggered}
              />
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default InfaqReport;
